import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../../entity/entity.types';
import { EntityCasesByJurisdiction } from '../../../entity/expertises/EntityCasesByJurisdiction';
import { EntityDomains } from '../../../entity/expertises/EntityDomains';
import { EntityCasesByCity } from '../../../entity/expertises/EntityCasesByCity';
import { LawyerKeywordsFetcher } from './LawyerKeywordsFetcher';
import { EntityKeywords } from '../../../entity/expertises/keywords/EntityKeywords';
import { withLawyer } from '../LawyerContext';
import { LawyerContextType } from '../lawyer.types';

type Props = {
  dontShowHref: boolean;
} & LawyerContextType;

export class RawLawyerCases extends React.Component<Props> {
  id = 'lawyer-expertises';

  componentDidMount() {
    window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
  }

  render() {
    const {
      lawyerInfos: { lawyerId },
      lawyerName,
      dontShowHref,
      experience: { domains, juridictions, villes, decisionCount },
    } = this.props;

    if (!domains.length && !juridictions.length && !villes.length) return null;

    const entityInfos: {
      entityId: string;
      entityName: string;
      entityType: EntityType;
    } = {
      entityId: lawyerId,
      entityName: lawyerName,
      entityType: 'lawyer',
    };
    return (
      <>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage
            id="app.pages.lawyer.expertises.title"
            values={{ lawyerName }}
          />
        </h2>
        {domains.length > 0 && (
          <EntityDomains
            domains={domains}
            decisionCount={decisionCount}
            dontShowHref={dontShowHref}
            {...entityInfos}
          />
        )}
        {juridictions.length > 0 && (
          <EntityCasesByJurisdiction
            casesByJurisdiction={juridictions}
            decisionCount={decisionCount}
            dontShowHref={dontShowHref}
            {...entityInfos}
          />
        )}
        {villes.length > 0 && (
          <EntityCasesByCity
            casesByCity={villes}
            decisionCount={decisionCount}
            dontShowHref={dontShowHref}
            {...entityInfos}
          />
        )}
        <LawyerKeywordsFetcher lawyerId={lawyerId}>
          {keywords =>
            keywords.length > 0 && (
              <EntityKeywords
                keywords={keywords}
                decisionCount={decisionCount}
                dontShowHref={dontShowHref}
                {...entityInfos}
              />
            )
          }
        </LawyerKeywordsFetcher>
      </>
    );
  }
}

export const LawyerCases = withLawyer(RawLawyerCases);
